import { COOKIES } from "constants/cookies";
import { eraseCookie, getCookie, setCookie } from "./cookies";
import { INTERNAL_PATHS } from "routes/paths";

export const setUserToken = ({ token, days = 1 }) => {
  setCookie({ name: COOKIES.TOKEN, value: token, days });
};

export const getUserToken = () => {
  return getCookie(COOKIES.TOKEN) ?? null;
};

export const clearAuthCookies = () => {
  eraseCookie(COOKIES.TOKEN);
  eraseCookie(COOKIES.USER_UUID);
};

export const userLogOut = () => {
  clearAuthCookies();
  window.open(INTERNAL_PATHS.HOME, "_self");
};

const shouldValidateDeviceByUserToken = ({ token }) => {
  const decodedToken = decodeJWT(token);
  return !!decodedToken?.payload?.device_fingerprint;
};

export const deviceNeedsVerification = ({ isLoggedIn }) => {
  if (!isLoggedIn) return false;

  const userToken = getUserToken();
  if (!userToken) return false;

  return shouldValidateDeviceByUserToken({ token: userToken });
};

export const decodeJWT = (token) => {
  if (!token) return null;

  const parts = token.split(".");
  if (parts.length !== 3) return null;

  const header = JSON.parse(atob(parts[0]));
  const payload = JSON.parse(atob(parts[1]));

  return {
    header,
    payload
  };
};
